<template>
    <v-app>
        <!-- isFullScreen === false 일 때만 앱 셸. 초기 빈 meta에서 셸이 먼저 그려지지 않게 함 -->
        <template v-if="useAppShell">
            <Header />

            <LeftMenu v-if="mdAndUp" />

            <v-main class="main-wrapper app-shell-main">
                <div class="main-content">
                    <router-view />
                </div>
            </v-main>

            <Footer v-if="mdAndUp" />
            <MobileBottomNav />
            <PwaInstallHint />
            <GuestWelcomeDialog />
            <BankbookDepositDialog />
        </template>
        <template v-else>
            <router-view />
        </template>
    </v-app>
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue'
import { useDisplay } from 'vuetify'
import { useRoute } from 'vue-router'

const Header = defineAsyncComponent(() => import('./Header.vue'))
const LeftMenu = defineAsyncComponent(() => import('./LeftMenu.vue'))
const Footer = defineAsyncComponent(() => import('./Footer.vue'))
const MobileBottomNav = defineAsyncComponent(() => import('./MobileBottomNav.vue'))
const PwaInstallHint = defineAsyncComponent(() => import('@/components/PwaInstallHint.vue'))
const GuestWelcomeDialog = defineAsyncComponent(() => import('@/components/GuestWelcomeDialog.vue'))
const BankbookDepositDialog = defineAsyncComponent(() => import('@/components/BankbookDepositDialog.vue'))

const route = useRoute()
const { mdAndUp } = useDisplay()
const useAppShell = computed(() => route.meta.isFullScreen === false)
</script>

<style>
.v-application {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.v-application .v-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: rgb(var(--v-theme-background));
    overflow-x: hidden;
}

/* 데스크톱: v-navigation-drawer(app)가 --v-layout-left 를 잡음 — 여기서 0으로 덮지 않음 */
</style>

<style scoped>
.main-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.main-content {
    flex: 1 1 auto;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    padding: 20px;
    background: rgb(var(--v-theme-background));
    overflow-x: hidden;
    min-height: 0;
}

@media (max-width: 959px) {
    .main-content {
        padding: 12px 12px 0;
    }
}
</style>

<style>
/* 모바일만: 드로어 없을 때 v-main 전체 너비 */
@media (max-width: 959px) {
    .app-shell-main {
        width: 100%;
        max-width: 100%;
        padding-left: 0 !important;
        padding-right: 0 !important;
        --v-layout-left: 0px !important;
        --v-layout-right: 0px !important;
        padding-bottom: calc(56px + env(safe-area-inset-bottom, 0px)) !important;
    }
}
</style>
